export default __webpack_public_path__ + "static/media/share_svg.ac22cacd.svg";